import React from "react";
import Form from "../../home/Apply/Form";
import Underline from "./Underline";
import { APPLY_ANCHOR_ID } from "../InstantCash/anchors";
import { ReactComponent as Feather } from "../../../../assets/landing/patria-feather.svg";
import {
  Wrapper,
  Feather as FeatherSlot,
  Inner,
  Copy,
  CardWrap,
  Sticker,
  Card,
} from "./Hero.styles";

const checks = [
  "60-second application",
  "No hard credit pull",
  "Deposits often in minutes",
];

const pills = ["Bank-level security", "No hidden fees", "Tribal-owned"];

/** the reference labels these fields differently from the shared form defaults */
export const FORM_PLACEHOLDERS = {
  requestedLoan: "Loan amount",
  reason: "What's it for?",
  ssn: "SSN",
  phoneNumber: "Phone",
  email: "Email",
};

const Check = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 12l4 4L19 6" />
  </svg>
);

const Hero = ({ directMailUrl }: { directMailUrl?: string }) => {
  return (
    <Wrapper className="section-lp2-hero">
      <FeatherSlot aria-hidden="true">
        <Feather />
      </FeatherSlot>

      <Inner>
        <Copy>
          <p className="eyebrow">
            <span className="dot" />
            Trusted by 40M+ Americans
          </p>

          <h1 className="headline">
            <span className="line-white">Unexpected Bill?</span>
            <span className="line-ink">
              Get Cash Fast.
              <Underline />
            </span>
          </h1>

          <p className="subhead">
            Apply in minutes. Money in your account as soon as{" "}
            <strong>today</strong>. Short-term loans up to $2,000 — honest
            terms, no surprises.
          </p>

          <ul className="checks">
            {checks.map((label) => (
              <li className="check" key={label}>
                <span className="check-icon">
                  <Check />
                </span>
                {label}
              </li>
            ))}
          </ul>

          <div className="pills">
            {pills.map((label) => (
              <span className="pill" key={label}>
                {label}
              </span>
            ))}
          </div>
        </Copy>

        <CardWrap id={APPLY_ANCHOR_ID}>
          <Sticker>Up to $2,000</Sticker>

          <Card className="form-wrapper">
            <p className="card-eyebrow">Check your approval</p>
            <h2 className="card-heading">
              See what you qualify for in{" "}
              <span className="accent">30 seconds</span>.
            </h2>
            <p className="card-note">No hard credit pull. No obligation.</p>
            <div className="card-form">
              <Form
                applyButtonLabel="Apply now"
                placeholders={FORM_PLACEHOLDERS}
              />
              {directMailUrl ? (
                <p className="mail-note">
                  Pre-approved by mail?{" "}
                  <a href={directMailUrl} target="_blank" rel="noreferrer">
                    Click here
                  </a>
                </p>
              ) : null}
            </div>
          </Card>
        </CardWrap>
      </Inner>
    </Wrapper>
  );
};

export default Hero;
